import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {LocalStorageService} from '../services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationGuardService implements CanActivateChild, CanActivate {
  ready: boolean;
  constructor(private router: Router, private route: ActivatedRoute, private localStorageService: LocalStorageService) {
    this.ready = false;
    this.route.queryParams
        .subscribe(params => {
          localStorage.setItem('returnUrl', params.return);
        });
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (this.localStorageService.get('token')) {
        const user = JSON.parse(this.localStorageService.get('user'));
        if (user.is_valid) {
          return true;
        } else {
          await this.router.navigate(['initialize']);
          return false;
        }
      } else {
        // await this.router.navigate(['login']);
        await  this.router.navigate(['/login'], {
          queryParams: {
            return: state.url
          }
        });
        return false;
      }
  }

  async canActivateChild() {
    // Check For Token validation????

    if (this.localStorageService.get('token')) {
      return true;
    } else {
      await this.router.navigate(['login']);
      return false;
    }
  }
}
